export const scrollToElementId = (id = 'error-box', option = {}) => {
  setImmediate(() => {
    const scrollElement = document.getElementById(id)
    if (scrollElement) scrollElement.scrollIntoView(option)
  })
}

export const scrollToElement = (element, options = { behavior: 'smooth', block: 'center' }) => {
  element?.scrollIntoView(options)
}
